import React from "react"
import { ReactComponent as MenuSVG } from "../../lib/assets/icons/menu.svg"
import { ReactComponent as MaxStake } from "../../lib/assets/icons/maxStake.svg"
import { ReactComponent as RefreshSVG } from "../../astro/board/footer/footersUI/placeBet/third/refresh.svg"
import { ReactComponent as AutoSVG } from "../../astro/board/footer/footersUI/placeBet/third/auto.svg"
import { colors } from "../../lib/colors"

export const GAME_DESCRIPTION = {
  title: "Astro",
  description: [
    "Astro is Orbital’s brand new and one of the easiest games that make the game outcomes random. Playing Astro, you can quickly and easily win money. Rules are simple: place a bet before the rocket takes off. Before starting a new round, make your desired bet or use the autoplay function. And Try to fly as high as possible without crashing into the asteroids.",
    "Win Calculation: If you manage to avoid asteroids and jump sheep before explosion you will win your CURRENT BET AMOUNT x MULTIPLIER.",
    "The last 20 bets are shown in history as my bets, all bets and high rollers",
    "Min multiplier in manual mode  is 1x",
    "Max multiplier in  manual mode is 5000x",
    "Min multiplier in autoplay is 1.01x",
    "Max multiplier in autoplay is 5000x",
    "The maximum possible amount at Cashout could be calculated by multiplying the maximum bet amount by the maximum payout (5000x)",
    "Malfunction voids all pays and plays",
  ],
}

export const settings = [
  {
    icon: <MenuSVG className="menu" />,
    title: "Settings Button",
    description: "Press the button to access Settings",
    background: colors.secondary,
    color: colors.tertiaryDark,
  },
  // {
  //   title: "Provably Fair",
  //   description:
  //     "This section grants you the possibility of checking the fairness of the game for yourself",
  // },
  {
    title: "Game Rules",
    description: "Short Description of the Game",
  },
  {
    title: "History",
    description:
      "Shows your previous plays and allows you to devise new tactics for your next round",
  },
  // {
  //   title: "Bet Reply",
  //   description: "Click on any bet in history page to see your bet reply",
  // },
  {
    title: "Music",
    description: "Turn on the unique audio overlay of the game",
  },
  {
    title: "Sound",
    description: "Enable unique action sounds of the game",
  },
  {
    title: "Volume Bar",
    description: "Set the volume",
  },
]

export const GameplayCustomization = [
  {
    title: "Place your bet",
    description: "Make your bet before rocket takes off",
    icon: "Play",
    background: colors.secondary,
    textColor: colors.tertiaryDark,
    size: "16px",
    width: "105px",
    height: "56px",
  },
  {
    title: "Cancel",
    description: "Cancel your bet before next launch",
    icon: "Cancel",
    background: colors.secondary,
    textColor: colors.tertiaryDark,
    size: "16px",
    width: "105px",
    height: "56px",
  },
  {
    title: "MAX Bet",
    description:
      "Within the betting buttons we have infinity symbol through which you can raise your bet to maximum with Just one click",
    icon: <MaxStake />,
    background: colors.secondary,
    textColor: colors.tertiaryDark,
    size: "12px",
  },
  {
    title: "CLEAR",
    description:
      "Button is disabled while bet amount equals minimum bet value and after it is above the minimum value allows the player to reset the bet amount to the default minimal value",
    icon: <RefreshSVG />,
    background: colors.secondary,
    textColor: colors.tertiaryDark,
    size: "12px",
  },
  {
    title: "AUTOPLAY MENU",
    description: "Using this button you can access autoplay configuration page",
    icon: <AutoSVG />,
    background: colors.secondary,
    textColor: colors.tertiaryDark,
    size: "12px",
  },
  {
    title: "Cash-out",
    description: "Cash out before the rocket explodes",
    background: colors.primaryDark,
    textColor: colors.secondary,
    size: "12px",
    width: "105px",
    height: "36px",
  },
  {
    title: "Show stats",
    description: "You can see the statistics of the game",
    background: colors.secondary,
    textColor: colors.primaryDark,
    size: "12px",
    width: "105px",
    height: "36px",
  },
  {
    title: "Live bets",
    description: "Shows the number of live bets",
    background: colors.secondary,
    textColor: colors.primaryDark,
    size: "12px",
    width: "105px",
    height: "36px",
  },
  {
    title: "Asteroid impact alert",
    description:
      "Twinkling red dot indicates that rocket is going to crash soon",
    background: colors.secondary,
    textColor: colors.primaryDark,
    size: "12px",
    width: "105px",
    height: "36px",
  },
]
// export const ButtonContent = [

//   {
//     name: "CHECK",
//     class: "check",
//     title: "Check Button",
//     description:
//       "In case of a not-so-good card, press the Check button, and the 5th card (river) is dealt on the table (face-up) without automatically making a bet on the Ante bet amount in the River position. The dealer`s cards are opened and the winner is revealed.",
//     icon: <Check />,
//     background: colors.primaryDark,
//     color: colors.quaternary,
//     size: "12px",
//   },
//   {
//     name: "BET",
//     class: "bet",
//     title: "Bet Button",
//     description:
//       "In case of a good card combination, press the BET button and the ante amount bet is automatically placed in the next position.",
//     icon: <Bet />,
//     background: colors.secondary,
//     color: colors.tertiary,
//     size: "12px",
//   },
// ]
export const otherCoefs = {
  coefs: ["2", "2", "2", "2", "2", "2", "2", "2", "2", "2"],
}

export const GeneralConditions = [
  {
    title: "Delayed Cashout",
    description:
      "It may happen in the game that you click CASHOUT, but the rocket explodes, and your bet is considered LOST, this happens due to lag, which can occur even in good internet conditions, so to avoid the risk, we recommend you to use the AUTOCASHOUT function",
  },
  {
    title: "*ERROR MAY OCCUR",
    description: "STAGE TIMEOUT",
  },
  {
    title: "Place Bet Error",
    description:
      "It may happen in the game that you click PLAY to place  bet, but the response is delayed, so your bet is considered LOST, this happens due to lag, which can occur even in good internet conditions, in order to avoid the risk,  to avoid place bet error, Bet during current round before or after shuttle explodes or during Next Launch progress bar before it reaches middle; bet will be on hold for  the next round thus your balance wont be deducted. On hold bet  will be placed after the Next Launch Progress bar finishes loading. You can cancel on hold bet while the current round is in progress but as soon as Next Launch progress bar begins your bet will be placed and you wont be able to cancel it",
  },
  {
    title: "What if you get disconnected?",
    description:
      "In case if you encounter a connection problem or accidentally refresh the page, no need to worry as we have thought it all and game conditions will be as followed",
  },
  {
    title: "Manual Game",
    description:
      "Will continue as far as this round can go, until the rocket crashes, if you get disconnected or refresh the page before the unlucky disaster you will be presented with the cashout at button as before disconnection, however in case if unlucky disaster struck and rocket exploded during the disconnection your round is lost , you can see the round result in game history or round history train",
  },
  {
    title: "Autoplay",
    description:
      "Will continue as far as this round can go, until the rocket crashes, if you get disconnected or refresh the page, before the unlucky disaster strikes, you will be presented with the cashout at button as before disconnection, however in case if the unlucky disaster struck and rocket exploded during disconnection your round is lost, you can see round result in game history or round history train",
  },
]

export const AutoRules = [
  {
    title: "Number Of Bets",
    description:
      "How many bets you want to be placed automatocally. Default value if not chanhed is infinity. No min max value 4 digit number maximum",
  },
  { title: "Start Auto", description: "Click to begin Autoplay" },
  { title: "Back", description: "Returns you to manual game page" },
]
